<template>
  <div class="ali-player-wrapper">
    <!-- <div>阿里云播放器</div> -->
    <div id="ali-player-con"></div>
  </div>
</template>
<script setup>
// https://help.aliyun.com/zh/vod/developer-reference/basic-features?spm=a2c4g.11186623.0.0.6e374634HCZlpg
import { ref, defineProps, onMounted, defineEmits, watch } from "vue";
const props = defineProps({
  source: String,
  isLive: Boolean,
  liveStartTime: String,
  cover: String,
  canAppoint: Boolean,
});
const emit = defineEmits(["canPlay"]);
let player = ref(null);
const isStart = ref(false);
const init = () => {
  if (player.value) {
    player.value.loadByUrl(props.source);
  } else {
    document.getElementById("ali-player-con").innerHTML = "";
    player.value = new Aliplayer(
      {
        id: "ali-player-con",
        width: "100%",
        height: "100%",
        autoplay: true,
        preload: false,
        source: props.source || "",
        isLive: props.isLive,
        cover: props.cover || "",
        // skinLayout: [
        //     {
        //       name: "bigPlayButton",
        //       align: "cc",
        //     },
        // ],
      },
      function () {
        console.log("播放器创建成功");
        // player.play();
      }
    );
    player.value.on("ready", function () {
      //   console.log("ready");
    });
    player.value.on("canplay", () => {
      emit("canPlay", player.value);
    });
    player.value.on("error", (e) => {
      console.log("视频出错了", e);
      // 没有推流的错误
      const ele = document.querySelector(".prism-ErrorMessage");
      if (
        e.paramData &&
        (e.paramData.error_code == 4004 || e.paramData.error_code == 4400)
      ) {
        const img = document.createElement("img");
        img.src = props.cover;
        img.id = "prism-img-cover";
        ele.appendChild(img);
      } else {
        const errorImg = document.getElementById("prism-img-cover");
        errorImg && ele.removeChild(errorImg);
      }
    });
    player.value.on("onM3u8Retry", function () {
      console.log("主播暂时离开，请稍后......");
    });
    player.value.on("liveStreamStop", function () {
      console.log("直播已结束");
    });
  }
};

watch(
  () => props.source,
  () => {
    // console.log("视频地址", val);
    // if (isStart.value) {
    init();
    // }
  }
);
watch(isStart, (val) => {
  if (val) {
    // console.log("直播开始了");
    init();
  }
});
function getRestTime(targetTime) {
  // console.log("status", status);
  const now = new Date().getTime();
  targetTime = targetTime ? new Date(targetTime).getTime() : now;
  if (now >= targetTime) {
    isStart.value = true;
  } else {
    setTimeout(() => {
      // console.log( "执行中");
      getRestTime(targetTime);
    }, 1000);
  }
}
onMounted(() => {
  if (props.canAppoint) {
    getRestTime(props.liveStartTime);
  } else {
    init();
  }
});
</script>
<style lang="less" scoped>
.ali-player-wrapper {
  width: 100%;
  height: 100%;

  ::v-deep(.prism-ErrorMessage) {
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
